import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import { Box, Divider, Typography, Grid, Button, Container, Fab, FormControl, TextField, Autocomplete,
            Paper, CircularProgress } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

function EditarCotizacion() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState({
        cliente: '',
        descripcion: '',
        estatus: '',
    });
    const [fechaDeCotizacion, setFechaDeCotizacion] = useState(DateTime.now());
    const [fechaDeEntrega, setFechaDeEntrega] = useState(DateTime.now());
    const [loading, setLoading] = useState(true);
    
    const [clientes, setClientes] = useState([
        {id: 1, nombre: 'Cliente 1'},
        {id: 2, nombre: 'Cliente 2'},
        {id: 3, nombre: 'Cliente 3'},
        {id: 4, nombre: 'Cliente 4'},
        {id: 5, nombre: 'Cliente 5'},
    ]);
    
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const estatus = ['Pendiente', 'Confirmado', 'Pagado', 'Surtido', 'Entregado', 'Cancelado'];
    const formaDePago = ['Efectivo', 'Tarjeta', 'Transferencia', 'Cheque'];

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Editar Cotización';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
       getData();
       return () => { }
   }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/orders/${id}`);
            if(res.status === 200) {
                setData(res.data);
                res.data.fechaDeCotizacion ? setFechaDeCotizacion(DateTime.fromISO(res.data.fechaDeCotizacion)) : setFechaDeCotizacion(DateTime.now());
                res.data.fechaDeEntrega ? setFechaDeEntrega(DateTime.fromISO(res.data.fechaDeEntrega)) : setFechaDeEntrega();
                setLoading(false);
            }
            res = await axios.get('/api/clients/');
            if (res.status === 200) {
                setClientes(res.data);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar la cotización, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            setLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const order = data;
        order.fechaDeCotizacion = fechaDeCotizacion;
        order.fechaDeEntrega = fechaDeEntrega;
        
        try {
            const res = await axios.post(`/api/orders/${data._id}`, { order: order });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Cotización actualizada', severity: 'success' } });
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al actualizar la cotización, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :
                <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                    <Container maxWidth='xl'>
                        <Box className='text-center' >
                            <Typography variant='h5' style={{ fontWeight: 700 }}>Editar Cotización</Typography>
                        </Box>

                        <Button size='small' variant='outlined' onClick={() => navigate('/cotizaciones')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la cotización' className='text-bold' />
                        </Divider>

                        <form onSubmit={(e) => handleSubmit(e)}>
                            <Fab aria-label="add" type='submit' color='success' style={{ position: 'fixed', top: '60px', left: '12px', zIndex: '10', opacity: '60%' }}>
                                <i className="fad fa-save fa-2x"></i>
                            </Fab>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={7}>
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <Autocomplete
                                            disablePortal
                                            freeSolo={true}
                                            onInputChange={(event, newInputValue) => setData({...data, cliente: newInputValue})}
                                            inputValue={data.cliente}
                                            aria-multiline='true'
                                            options={clientes.map((option) => option.name)}
                                            renderInput={(params) => <TextField {...params} label='Cliente' />}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={5}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <DatePicker
                                            label="Fecha de Cotización"
                                            format="dd/MM/yyyy"
                                            value={fechaDeCotizacion}
                                            onChange={(newValue) => setFechaDeCotizacion(newValue)}
                                            slotProps={{ textField: { variant: 'outlined' } }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={8}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" multiline variant="outlined" value={data.descripcion} onChange={(e) => setData({...data, descripcion: e.target.value})} />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <Autocomplete
                                            disablePortal
                                            freeSolo={true}
                                            onInputChange={(event, newInputValue) => setData({...data, estatus: newInputValue})}
                                            inputValue={data.estatus}
                                            value={data.estatus}
                                            defaultValue={data.estatus}
                                            options={estatus}
                                            renderInput={(params) => <TextField {...params} label='Estatus' />}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <DatePicker
                                            label="Fecha de Entrega"
                                            format="dd/MM/yyyy"
                                            value={fechaDeEntrega}
                                            onChange={(newValue) => setFechaDeEntrega(newValue)}
                                            slotProps={{ textField: { variant: 'outlined' } }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <Autocomplete
                                            disablePortal
                                            freeSolo={false}
                                            onInputChange={(event, newInputValue) => setData({...data, formaDePago: newInputValue})}
                                            inputValue={data.formaDePago}
                                            value={data.formaDePago}
                                            defaultValue={data.formaDePago}
                                            options={formaDePago}
                                            renderInput={(params) => <TextField {...params} label='Forma de Pago' />}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <hr></hr>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Button variant="contained" color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Container>
                    <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                </Paper>
            }
        </Container>
    );
}

export default EditarCotizacion;